/**
 * Pre-compiled es messages for PasswordInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { hide: `Ocultar contraseña`, show: `Mostrar contraseña` };
